import React, { useState } from 'react';
import { User, Mail, MessageSquare, Send } from 'lucide-react';
import Footer from '../navigation/footer';
import contactImage from '../assets/lights.png';

const GridPattern = () => (
  <div className="absolute right-0 top-0 h-full w-[300px] overflow-hidden pointer-events-none">
    <div className="grid grid-cols-6 gap-2 h-full p-8">
      {Array.from({ length: 120 }).map((_, index) => (
        <div
          key={index}
          className="w-8 h-8 border border-gray-700/50 rounded-sm"
          style={{
            transform: index % 2 === 0 ? 'rotate(45deg)' : 'rotate(0deg)',
            opacity: Math.random() * 0.5 + 0.1
          }}
        />
      ))}
    </div>
  </div>
);

const Contact = () => {
  const [msg, setMsg] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    const scriptURL =
      'https://script.google.com/macros/s/AKfycbzXzduA3dY6PpAdMGQzDIskcywVHBkgMkzs0ZOg_iXSX3Gr-EVBCSbbVOhAw-xi0qhL/exec';

    try {
      const response = await fetch(scriptURL, { method: 'POST', body: formData });
      if (response.ok) {
        setMsg('Message sent successfully');
        setTimeout(() => setMsg(''), 5000);
        form.reset();
      }
    } catch (error) {
      console.error('Error!', error.message);
    }
  };

  return (
    <>
      <div id="contact" className="py-16 bg-black min-h-screen flex flex-col items-center relative">
        {/* Top-left Image */}
        <img 
          src={contactImage} 
          alt="Decorative" 
          className="absolute top-0 left-4 w-90 h-80 object-contain"
        />

        {/* Grid Pattern */}
        <GridPattern />

        {/* Main Form Container */}
        <div className="relative z-10 max-w-2xl w-full mx-auto px-8 py-12 bg-gray-900/50 backdrop-blur-sm rounded-2xl border border-gray-800 shadow-xl">
          {/* Header with animated border */}
          <div className="text-center mb-12 relative">
            <h1 className="text-4xl font-bold text-white mb-3">Let's Connect</h1>
            <div className="w-24 h-1 bg-orange-600 mx-auto rounded-full"></div>
          </div>

          {/* Form */}
          <form name="submit-to-google-sheet" onSubmit={handleSubmit} className="space-y-6">
            {/* Name Input */}
            <div className="relative">
              <User className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                name="Name"
                placeholder="Your Name"
                required
                className="w-full bg-gray-800/50 text-white py-4 pl-12 pr-6 rounded-lg focus:outline-none border border-gray-700 hover:border-orange-600"
              />
            </div>

            {/* Email Input */}
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
                className="w-full bg-gray-800/50 text-white py-4 pl-12 pr-6 rounded-lg focus:outline-none border border-gray-700 hover:border-orange-600"
              />
            </div>

            {/* Message Input */}
            <div className="relative">
              <MessageSquare className="absolute left-4 top-6 text-gray-400 w-5 h-5" />
              <textarea
                name="Message"
                rows="6"
                placeholder="Your Message"
                required
                className="w-full bg-gray-800/50 text-white py-4 pl-12 pr-6 rounded-lg focus:outline-none border border-gray-700 hover:border-orange-600"
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="flex justify-center">
              <button
                type="submit"
                className="group relative text-xl bg-black text-white border-2 w-[300px] py-2 px-4 rounded-lg hover:ring-2 hover:ring-orange-600 shadow-sm transition-all duration-300 flex items-center justify-center gap-x-2 hover:shadow-lg hover:shadow-orange-600/25"
              >
                <span className="flex items-center">Send Message</span>
                <Send className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-300" />
              </button>
            </div>
          </form>

          {/* Success Message */}
          {msg && (
            <div className="mt-6 text-center">
              <span className="text-green-500 bg-green-500/10 px-4 py-2 rounded-full">{msg}</span>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact;